/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(t,s,e){this.material=t,this.techniques=s,this.textures=e}}export{t as GLMaterialParameters};
